import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import {AYLA_ALLOWED_ROLES, DSNS_DROPDOWN_VALUES, REGIONS, REGIONS_FOR_VPC, REGIONS_FOR_EU, REGIONS_FOR_US, GoogleAnalyticsConstants} from '../../../constants';
import { numberFormatter } from '../../../helpers/formatter';
import * as reportsservice from '../../../services/reportsservice';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {date_range, dsns, oem_id, oem_model, region_name} from '../../filters/filterPanel/FilterPanel';
import MeteringNavBar from '../../meteringNavBar/MeteringNavBar';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import ValueDisplayReport from '../../reports/meteringValueDisplayReport/valueDisplayReport';
import '../meteringPage/MeteringPage.css';
import { logPageViewEvent } from '../../../services/analyticsservice';
import {getReportData} from "../../../helpers/utils";

class TransactionsPage extends ReportPage {
  // this is needed when page has dependency on contracts data and will tell to reportsPage to call the contractData
  isContractDataRequired = true;
  isTransactionsPage = true;

  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.Metering.title, logged_in_oem_id);
  }

  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (this.props.presistFilters.region_name === 'US-VPC'
        && this.props.presistFilters.oem_id === '39a9391a');

    filters.dsns = 'All';
    return {
      filters: [
        reportsservice.listOfOems(filters),
        reportsservice.contractlistOfOemModels(filters)
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
        reportsservice.contractDatapointsTransactionsOverTime(filters),
        reportsservice.contractTotalDatapointsTransactions(filters),
        reportsservice.totalTransactionsOverTime(filters),
        reportsservice.contractTotalDatastreamTransactions(filters),
        reportsservice.contractDatastreamTransactionsOverTime(filters),
        reportsservice.contractSmsTransactionsOverTime(filters),
        reportsservice.contractSmsTransactions(filters),
        reportsservice.contractRuleEvaluationTransactions(filters),
        reportsservice.contractRuleEvaluationTransactionsOverTime(filters),
        reportsservice.contractRuleExecutionTransactions(filters),
        reportsservice.contractRuleExecutionTransactionsOverTime(filters),
      ] : [
        reportsservice.totalTransactions(filters),
        reportsservice.datapointTransactions(filters),
        reportsservice.datastreamTransactions(filters),
        reportsservice.transactionsOverTime(filters),
        reportsservice.datapointTransactionsOverTime(filters),
        reportsservice.datastreamTransactionsOverTime(filters),
      ],
    };
  }

  render() {
    const { fetchData, isMeteringApi, session} = this.props;
    let datapointsTransactions, datastreamTransactions, smsTransactions, ruleEvaluationTransactions,
      ruleExecutionTransactions, totalTransactions = null;
    if (isMeteringApi) {
      datapointsTransactions = this.report(reportsservice.contractTotalDatapointsTransactions);
      datastreamTransactions = this.report(reportsservice.contractTotalDatastreamTransactions);
      smsTransactions = this.report(reportsservice.contractSmsTransactions);
      ruleEvaluationTransactions = this.report(reportsservice.contractRuleEvaluationTransactions);
      ruleExecutionTransactions = this.report(reportsservice.contractRuleExecutionTransactions);
      totalTransactions = numberFormatter(this.getTotalTransactions(
        datapointsTransactions,
        datastreamTransactions,
        smsTransactions,
        ruleEvaluationTransactions,
        ruleExecutionTransactions
      ));
    }

    return (
      <div className="TransactionsPage page">
        <TitleBar title="Billing Data" />
        <MeteringNavBar />
        <div className="page-content-wrapper metering-page-content-wrapper container-flex">
          <div className="pageContent metering-page-content">
            <FilterPanel disabled={fetchData.fetches > 0}
              currentFilters={this.props.presistFilters}
              filters={[
                AYLA_ALLOWED_ROLES.includes(session && session.role) && oem_id(this.report(reportsservice.listOfOems)),
                date_range,
                process.env.REACT_APP_IS_VPC_ENVIRNOMENT === 'true'
                  ? region_name(REGIONS_FOR_VPC)
                  : process.env.REACT_APP_IS_US_ENVIRNOMENT === 'true'
                  ? region_name(REGIONS_FOR_US)
                  : process.env.REACT_APP_IS_EU_ENVIRNOMENT === 'true'
                    ? region_name(REGIONS_FOR_EU)
                    : region_name(REGIONS),
                oem_model(this.report(reportsservice.contractlistOfOemModels)),
                dsns(DSNS_DROPDOWN_VALUES),
              ]}
              hideDefaultReports
            />
            <DataSnapshot snapShot={this.dataSnapshotTime} />
            <div className="container-space-between">
              { isMeteringApi && <ValueDisplayReport title="meteringPage.transactionCounts"
                data={{
                  datapoint_details: {
                    'meteringPage.transactions.batchDatapoints': {
                      report: this.getDatapointReport('batch_datapoint', datapointsTransactions),
                    },
                    'meteringPage.transactions.singleDatapoints': {
                      report: this.getDatapointReport('single_datapoint', datapointsTransactions),
                    },
                  },
                  datapoint_id: ['batch-datapoints' , 'single-datapoints'],
                  details: {
                    'meteringPage.transactions.totalTransactions': {
                      report: totalTransactions === 0 ? '0' : totalTransactions,
                      reportDescription: {expanded_desc: t('meteringPage.toolTip.totalTransactions') }
                    },
                    'meteringPage.transactions.datapointTransactions': {
                      report: this.getDatapointReport('total_datapoint', datapointsTransactions),
                      reportDescription: {expanded_desc: t('meteringPage.toolTip.datapointTransactions') }
                    },
                    'meteringPage.transactions.datastreamTransactions': {
                      report:(datastreamTransactions && datastreamTransactions.hasOwnProperty('message'))
                          ? t('unableToFetchData') : (datastreamTransactions && datastreamTransactions.total_datastream)
                              ? numberFormatter(datastreamTransactions.total_datastream) : null,
                      reportDescription: {expanded_desc: t('meteringPage.toolTip.datastreamTransactions') }
                    },
                    'meteringPage.transactions.smsTransactions': {
                      report:(smsTransactions && smsTransactions.hasOwnProperty('message'))
                          ? t('unableToFetchData') : (smsTransactions && smsTransactions.sms)
                              ? numberFormatter(smsTransactions.sms) : null,
                      reportDescription: {expanded_desc: t('meteringPage.toolTip.smsTransactions') }
                    },
                    'meteringPage.transactions.ruleTransactions': {
                      report: this.getRuleTransactionsReport(ruleEvaluationTransactions, ruleExecutionTransactions),
                      reportDescription: {expanded_desc: t('meteringPage.toolTip.ruleTransactions') }
                    }
                  },
                  id: ['total-transactions', 'datapoint-transactions', 'data-stream-transactions','sms-transactions',
                    'rule-transactions']
                }} width={100}
              />}
              { ! isMeteringApi &&
                <ValueDisplayReport
                  title="meteringPage.transactionCounts"
                  data={{
                    details: {
                      'meteringPage.transactions.totalTransactions': {
                        report: (this.report(reportsservice.totalTransactions)
                          && this.report(reportsservice.totalTransactions).hasOwnProperty('message'))
                          ? t('unableToFetchData')
                          : numberFormatter(this.report(reportsservice.totalTransactions)),
                        reportDescription: this.reportDescription(reportsservice.totalTransactions)
                      },
                      'meteringPage.transactions.datapointTransactions': {
                        report: (this.report(reportsservice.datapointTransactions)
                          && this.report(reportsservice.datapointTransactions).hasOwnProperty('message'))
                          ? t('unableToFetchData')
                          :numberFormatter(this.report(reportsservice.datapointTransactions)),
                        reportDescription: this.reportDescription(reportsservice.datapointTransactions)
                      },
                      'meteringPage.transactions.datastreamTransactions': {
                        report: (this.report(reportsservice.datastreamTransactions)
                          && this.report(reportsservice.datastreamTransactions).hasOwnProperty('message'))
                          ? t('unableToFetchData')
                          :numberFormatter(this.report(reportsservice.datastreamTransactions)),
                        reportDescription: this.reportDescription(reportsservice.datastreamTransactions)
                      }
                      },
                    id: ['total-transactions', 'datapoint-transactions', 'data-stream-transactions']
                  }} width={100}
                />
              }
            </div>
            <div className="metering-graph-content">
              <div className="metering-content-title-bar">
                <div className="metering-content-title">
                  <h2>{t('transactionTrends')}</h2>
                </div>
                <TimeAggregation value={this.props.presistFilters.aggregate_by} aggregateByDays />
              </div>
              {isMeteringApi ? (
                <>
                <div className="padding-graph">
                  <BarChart title="meteringPage.transactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={(this.report(reportsservice.totalTransactionsOverTime)
                      && this.report(reportsservice.totalTransactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.totalTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
                <div className="padding-graph">
                  <BarChart title="meteringPage.datapointTransactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={(this.report(reportsservice.contractDatapointsTransactionsOverTime)
                      && this.report(reportsservice.contractDatapointsTransactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.contractDatapointsTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    grouped
                  />
                </div>
                <div className="padding-graph">
                  <BarChart title="meteringPage.datastreamTransactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={this.report(reportsservice.contractDatastreamTransactionsOverTime)
                      && this.report(reportsservice.contractDatastreamTransactionsOverTime).hasOwnProperty('message')
                      ? t('unableToFetchData') : this.report(reportsservice.contractDatastreamTransactionsOverTime)}
                    description={this.reportDescription(reportsservice.contractDatastreamTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
                <div className="padding-graph">
                  <BarChart title="meteringPage.smsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={(this.report(reportsservice.contractSmsTransactionsOverTime)
                      && this.report(reportsservice.contractSmsTransactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.contractSmsTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
                <div className="padding-graph">
                  <BarChart title="meteringPage.ruleTransactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={this.getRuleTransactionsOverTime(
                      getReportData(
                        this.report(reportsservice.contractRuleEvaluationTransactionsOverTime),
                        'Contract_Rule_Evaluation_Transactions_Over_Time'),
                      getReportData(
                        this.report(reportsservice.contractRuleExecutionTransactionsOverTime),
                        'Contract_Rule_Execution_Transactions_Over_Time')
                    )}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    grouped
                  />
                </div>
              </>
              ) : (
                <>
                <div className="padding-graph">
                  <BarChart
                    title="meteringPage.transactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={(this.report(reportsservice.transactionsOverTime)
                      && this.report(reportsservice.transactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.transactionsOverTime)}
                    description={this.reportDescription(reportsservice.transactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
                <div className="padding-graph">
                  <BarChart
                    title="meteringPage.datapointTransactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data = {(this.report(reportsservice.datapointTransactionsOverTime)
                      && this.report(reportsservice.datapointTransactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.datapointTransactionsOverTime)}
                    description={this.reportDescription(reportsservice.datapointTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
                <div className="padding-graph">
                  <BarChart
                    title="meteringPage.datastreamTransactionsOverTime"
                    width={this.widthForColumns(1)}
                    height={200}
                    data={(this.report(reportsservice.datastreamTransactionsOverTime)
                      && this.report(reportsservice.datastreamTransactionsOverTime).hasOwnProperty('message'))
                      ? t('unableToFetchData') : this.report(reportsservice.datastreamTransactionsOverTime)}
                    description={this.reportDescription(reportsservice.datastreamTransactionsOverTime)}
                    xLabel={this.props.presistFilters.aggregate_by}
                    yLabel="transactions"
                    isMeteringPage
                  />
                </div>
              </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(TransactionsPage);
